import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo.svg'


const _withScopeId = n => (_pushScopeId("data-v-7cc9c2f1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "/",
  class: "logo"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Logo"
  })
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "lines" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Approved locations")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Uploaded locations")

import { ref, computed } from "vue";
import { useUserStore } from "@/stores/user";


export default /*#__PURE__*/_defineComponent({
  __name: 'NavComponent',
  setup(__props) {

const userStore = useUserStore();

const showLogout = computed(() => {
  return !userStore.user;
});

const showMenu = ref(false);

function openClose() {
  showMenu.value = !showMenu.value;
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("a", {
      onClick: openClose,
      class: _normalizeClass(["menuBtn", showMenu.value ? 'act' : ''])
    }, _hoisted_4, 2),
    _createElementVNode("nav", {
      class: _normalizeClass(["mainMenu", showMenu.value ? 'act' : ''])
    }, [
      _createElementVNode("ul", null, [
        _createElementVNode("li", null, [
          (!_unref(showLogout))
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                class: "loginA",
                onClick: _cache[0] || (_cache[0] = () => _unref(userStore).logout())
              }, "Log out"))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("li", null, [
          (!_unref(showLogout))
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                to: "/approved"
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("li", null, [
          (!_unref(showLogout))
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                to: "/"
              }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ])
    ], 2)
  ]))
}
}

})